import styles from "./index.module.scss";

function SliderControls({
  onPrev,
  onNext,
  prevActive,
  nextActive,
  customClass,
}) {
  return (
    <div className={`${styles.sliderControls} ${customClass}`}>
      <div
        className={prevActive ? styles.arrowLeftActive : styles.arrowLeft}
        onClick={() => (prevActive ? onPrev() : null)}
      />
      <div
        className={nextActive ? styles.arrowRightActive : styles.arrowRight}
        onClick={() => (nextActive ? onNext() : null)}
      />
    </div>
  );
}

export default SliderControls;
